import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function EditRateCard() {
  const { state: ratecard } = useLocation();
  const [description, setDescription] = useState(ratecard?.Description || "");
  const [serviceCharge, setServiceCharge] = useState(ratecard?.ServiceCharge || "");
  const [services, setServices] = useState([]);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchServices = async () => {
  //     try {
  //       const res = await axios.get("https://visitguru.in/api/v1/service/getService");
  //       setServices(res.data.data || []);
  //     } catch (error) {
  //       console.error("Failed to fetch services:", error);
  //       toast.error("Failed to load services.");
  //     }
  //   };
  //   fetchServices();
  // }, []);

  const handleUpdate = async () => {
    if (!description || !serviceCharge) {
      toast.error("Please fill all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("Description", description);
    formData.append("ServiceCharge", serviceCharge);
    formData.append("_id", ratecard._id);

    try {
      const response = await axios.patch(
        "https://visitguru.in/api/v1/ratecard/updateRateCard",
        formData
      );

      if (response.status === 200 || response.data.success) {
        toast.success("Rate Card updated successfully!");
        navigate("/admin/ratecard");
      } else {
        toast.error(response.data.message || "Update failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update rate card.");
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Edit Rate Card</h6>
        </div>
      </div>

      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* Select Service */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Title
            </label>
            {/* <select
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
            >
              <option value="">Select Service</option>
              {services.map((service) => (
                <option key={service._id} value={service._id}>
                  {service.serviceName}
                </option>
              ))}
            </select> */}

            <input
              type="text"
              placeholder="Enter Title"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {/* Service Charge */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Service Charge
            </label>
            <input
              type="number"
              placeholder="Enter Service Charge"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={serviceCharge}
              onChange={(e) => setServiceCharge(e.target.value)}
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end mt-8">
            <button
              type="button"
              onClick={() => navigate("/admin/ratecard")}
              className="bg-red-500 hover:bg-red-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-red-400 transition-all duration-150 mr-4"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleUpdate}
              className="bg-lightBlue-500 hover:bg-lightBlue-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-150"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditRateCard;
